import axios from 'axios';

export const getActiveWorkflow = async (token) => {
  try {
    const method = 'GET'; // isNewWorkflow ? 'POST' :
    const url = `${process.env.REACT_APP_PERSONALIZE_URL}/ecare/config`;

    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`, // Bearer token assumed
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API Call Failed:', error);
  } finally {
  }
};
